module.exports = __webpack_public_path__ + "static/media/Multi-disciplinary.30c9ccea.png";